export default __webpack_public_path__ + "static/media/WPI_logo_name_small.1415cc83.png";